export default __webpack_public_path__ + "static/media/logo.a775bbc1.png";